import createModel, { prop } from 'models/lib/create_model';
import { QuickReplyRequest } from 'models/chat_message_quick_reply_request';

export const QuickReplyResponse = createModel({
  modelName: 'QuickReplyResponse',

  properties: {
    quickReplyRequest: prop(QuickReplyRequest).isRequired,
    selectedOptionId: prop(String).isRequired,
    requestMessageId: prop(String),
  },
});
